import { useEffect } from "react";

import { analytics } from "@flare/analytics";

import { getAnonymousId } from "@/utils/anonymous-id";

export function useSetAnalyticsAnonymousId() {
  const anonymousId = getAnonymousId();

  useEffect(() => {
    if (anonymousId) {
      analytics.setAnonymousId(anonymousId);
    }
  }, [anonymousId]);
}
